<style lang="scss" scoped>
</style>

<template>
  <div>
    <div class="clearfix mb20">
      <tab :arr="arr"></tab>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import tab from '@/components/tab';

export default {
  components: {
    tab,
  },
  computed: {},
  props: ['id'],
  data() {
    return {
      type: this.$route.path,
      arr: [
        {
          name: '关注用户',
          url: `/third/${this.id}/usermana/index`,
        },
        {
          name: '取关用户',
          url: `/third/${this.id}/usermana/takeoff`,
        },
      ],
    };
  },
  mounted() {},
  methods: {
    router() {
      this.$router.push(this.type);
    },
  },
};
</script>
